var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from 'react';
import { NODE_SHADOW_FILTER_KEY } from '../link/ShadowFilters';
var NodeShape = function (_a) {
    var shape = _a.shape, fillColor = _a.fillColor, borderColor = _a.borderColor, withShadow = _a.withShadow;
    var NodeShapeComponent = shape.name;
    return (React.createElement(NodeShapeComponent, __assign({ className: 'interactiveNode__shape' }, shape.attrs, { filter: withShadow ? "url(#" + NODE_SHADOW_FILTER_KEY + ")" : undefined, style: {
            fill: fillColor,
            stroke: borderColor,
        } })));
};
export default NodeShape;
//# sourceMappingURL=NodeShape.js.map